import type { CopilotDraftGenerationProperties } from './CopilotDraftGenerationProperties';

export default function parseCopilotDraftGenerationProperties(
    value: unknown
): CopilotDraftGenerationProperties | undefined {
    if (typeof value !== 'string' || value.length === 0) {
        return undefined;
    }

    let parsed: {
        agentId?: unknown;
        source?: unknown;
        conversationId?: unknown;
        requestId?: unknown;
        createdDateTime?: unknown;
    };
    try {
        parsed = JSON.parse(value);
    } catch {
        return undefined;
    }
    if (!parsed || typeof parsed !== 'object') {
        return undefined;
    }

    return {
        agentId: typeof parsed.agentId === 'string' ? parsed.agentId : undefined,
        source: typeof parsed.source === 'string' ? parsed.source : undefined,
        sydneyConversationId:
            typeof parsed.conversationId === 'string' ? parsed.conversationId : undefined,
        requestId: typeof parsed.requestId === 'string' ? parsed.requestId : undefined,
        createdDateTime:
            typeof parsed.createdDateTime === 'string' ? parsed.createdDateTime : undefined,
    };
}
